<template>
  <div class='article-create'>
    <articles-form
        v-if='!isLoading'
        :data='article'
        :channels='channels'
        :header="article.title || 'Untitled'"
        :isRepublish='true'
    />
    <div
        v-else
        class='article-create__loader'
    >
      <loading-icon
          :loading='isLoading'
          loading-class='text-center vertical-middle'
      />
    </div>
  </div>
</template>

<script>
import ArticlesForm from './form/Form'

export default {
  name: 'RepublishArticle',

  components: {
    ArticlesForm
  },

  data() {
    return {
      article: null,
      channels: [],
      isLoading: true
    }
  },

  created() {
    this.getData()
  },

  methods: {
    async getData() {
      const { articleId } = this.$route.params
      try {
        //Check if the article has a draft already to republish to avoid creating new one.
        const { data: draftData } = await this.$http.get(`/articles/drafts/find/${articleId}`)
        if (!draftData.id) {
          this.article = await this.getArticleData(articleId)
        } else {
          this.article = this.getArticleDraftData(draftData, articleId)
        }
        this.isLoading = false

      } catch (err) {
        console.log(err)
      }
    },

    async getArticleData(articleId) {
      const { data: articleData } = await this.$http.get(`/articles/${articleId}`)

      const article = articleData.data
      article.analyst = article.analysts[0]
      article.companies = article.companies.map((company) => {
        const recommendation = article.company_recommendations.find((r) => r.company.id === company.id) || {}
        company.recommendation = recommendation
        company.security = recommendation.security ? recommendation.security.display_name : null
        company.security_id = recommendation.security ? recommendation.security.id : null
        return company
      })
      article.company_recommendations.forEach((r) => {
        if (!article.companies.find((c) => c.recommendation && c.recommendation.id === r.id)) {
          const rec = {
            ...r.company,
            recommendation: r,
            security: r.security ? r.security.display_name : null,
            security_id: r.security ? r.security.id : null
          }
          article.companies.push(rec)
        }
      })
      article.channel = article.channel_content_type.channel
      return article
    },

    getArticleDraftData(draftData, articleId) {
      let { id, ...article } = { ...draftData.latest_revision }
      article.article_id = articleId
      if (!article.analysts) {
        article.analysts = []
      } else if (article.analysts.length > 0) {
        article.analyst = article.analysts[0]
      }
      if (!article.tags) {
        article.tags = []
      }
      article.id = articleId
      article.channelId = article.channel.id
      article.revision_id = id
      return article;
    },

    setCompanies() {
      const { article } = this
      const companies = article.company_recommendations.filter(({ company = false }) => company).map((recc) => {
        const mappedCompany = {
          recommendation: {}
        }

        // eslint-disable-next-line camelcase
        const { id, company, target_price, currency, recommendation } = recc

        // eslint-disable-next-line camelcase
        if (target_price) {
          mappedCompany.recommendation.target_price = recommendation.target_price
        }

        if (currency) {
          mappedCompany.recommendation.target_price_currency = currency
          mappedCompany.recommendation.target_price_currency_id = currency.id
        }

        return {
          recommendation,
          id: company.id,
          name: company.name,
          company_recommendation_id: id,
          tag_id: company.tag_id,
          country: company.country
        }
      })
    }
  }
}
</script>

<style lang='scss'>
</style>

